import localScaleManager from "../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../helpers/tweensConfigs";
import SideMenuOverlay from "../sideMenuOverlay";

export class RealTimeResultsMenu {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.tableInfo = table.tableInfo;
    this.showMenu = false;
    this.pointerDown = false;
    this.icon = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "real-time-results-icon")
      .setOrigin(0);
    this.margin = 0;
    this.icon.setInteractive({ cursor: "pointer" });
    this.icon.on("pointerdown", this.onPointerDown, this);
    this.icon.on("pointerup", this.onPointerUp, this);

    this.registryName = "showRealTimeResultsMenu" | "showTournamentInfo";
    this.scene.registry.set("showTournamentInfo", false);
    this.scene.registry.set("showRealTimeResultsMenu", false);
    this.overlay = new SideMenuOverlay(scene, this.registryName);
  }
  onPointerDown() {
    this.pointerDown = true;
  }
  onPointerUp() {
    if (this.scene.isSceneObjectsInteractive && this.pointerDown) {
      this.showMenu = true;
      this.registryName = this.scene.getVisitedTable().isTournamentTable()
        ? "showTournamentInfo"
        : "showRealTimeResultsMenu";
      this.overlay.registryName = this.registryName;
      this.scene.registry.set(this.registryName, this.showMenu);
      this.overlay.show();
    }
    this.pointerDown = false;
  }
  changePosition(x) {
    const initPosition =
      this.scene.gameWidth - this.icon.displayWidth - this.margin;
    this.icon.setX(x + initPosition);
    this.overlay.reposition();
  }
  scrollTo(positionX) {
    const initPosition =
      this.scene.gameWidth - this.icon.displayWidth - this.margin;
    this.scene.tweens.add({
      targets: this.icon,
      x: initPosition + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
      onComplete: () => {
        this.updateTable();
        this.overlay.reposition();
      },
    });
  }
  hide() {
    if (!this.showMenu) return;
    this.scene.registry.set(this.registryName, false);
    this.overlay.hide();
    this.showMenu = false;
  }
  /**
   * tamame object hayii k az table in object(this.table) estefade mikonn bayad update shavand..
   */
  updateTable() {
    this.table = this.scene.getVisitedTable();
    this.tableInfo = this.table.tableInfo;
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  positionControls(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    let iconSize = Math.min(width / 15, height / 15);
    localScaleManager.scaleSprite(this.icon, iconSize, iconSize, 0, 1, true);
    this.icon.setPosition(
      this.scene.gameWidth - this.icon.displayWidth - this.margin,
      this.icon.displayHeight * 2
    );
    this.overlay.positionControls();
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  reposition(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    this.icon.setPosition(
      this.scene.gameWidth - this.icon.displayWidth - this.margin,
      this.icon.displayHeight * 2
    );
    this.overlay.reposition();
  }
}
